<template>
    <div class="modal fade share-bet-modal" id="qrShareModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered information-modal-wrapper">
            <div class="modal-content">
                <div class="modal-body">
                    <section class="sub-header-wrapper">
                        <div class="qrPreview-image login-by-social-icon">
                            <div class="footer-social-bx shared_social_img">
                                <div class="f-social-icon">
                                    <a :href="`https://telegram.me/share/url?url=${qrCode}`" target="_blank">
                                        <img src="@/assets/images/telegram.webp" alt="telegram" />
                                    </a>
                                </div>
                                <div class="f-social-icon">
                                    <a :href="`https://api.whatsapp.com/send?text=${encodeURIComponent(qrCode)}`" target="_blank">
                                        <img src="@/assets/images/whatsapp_img.png" alt="whatsapp" />
                                    </a>
                                </div>
                                <div class="f-social-icon">
                                    <a :href="`https://www.instagram.com/create/story?media=${qrCode}`" target="_blank">
                                        <img src="@/assets/images/instagram.webp" alt="instagram-icon" />
                                    </a>
                                </div>
                                <div class="f-social-icon">
                                    <a :href="`https://www.facebook.com/sharer/sharer.php?u=${qrCode}`" target="_blank">
                                        <img loading="lazy" src="@/assets/images/facebook.webp" alt="facebook-icon" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div class="modal-footer qr-close-footer">
                    <button type="button" data-bs-dismiss="modal" aria-label="Close">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'qrCodeShareModal',
    props: ['qrCode']
}
</script>